import React from "react";
import TopNav from "./TopNav";
import SideNav from "./SideNav";

export default function Header() {
  return (
    <>
      <TopNav />
      <SideNav />
    </>
  );
}
